import { Injectable, SkipSelf } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { EnvService } from 'src/app/env.service';
import { Observable } from 'rxjs';
import { AddRoleModel } from 'src/app/viewModels/roles/rolesdetail';
import { Constants } from 'src/app/middleware/common/reusableclassesAndFunctions/constants';
import { ApiEndPointsRoles } from '../apiURLs/api-end-points';


@Injectable({
  providedIn: 'root'
})
export class RoleService {
  private baseUrl:any;
  _content: string;
  constructor(@SkipSelf()private _http: HttpClient, private apiAddress: ApiEndPointsRoles,
   public env: EnvService, private constant: Constants) {
     
if( this.env.apiUrl==undefined  || this.env.apiUrl=='')
this.baseUrl = this.constant.RolePortNumber;
else
this.baseUrl = this.env.apiUrl+this.constant.RolePortNumber;

  }
   //private baseUrl = this.env.apiUrl;
  //private baseUrl = this.constant.RolePortNumber;
  //private baseUrl = this.env.apiUrl+this.constant.RolePortNumber;
  // private options_: any = {
  //   headers: new HttpHeaders({
  //     'Content-Type': 'application/json-patch+json',
  //     'Accept': 'text/plain'
  //   })
  // };

  // To get Role List
  getRoleList(data): Observable<any> {
    const apiURL = this.baseUrl + this.apiAddress.roleList;
    return this._http.post(apiURL, data).pipe();
  }
   // To add new Role
   addRole(data: AddRoleModel): Observable<any> {
    const apiURL = this.baseUrl + this.apiAddress.addRole;
    return this._http.post(apiURL, data).pipe();
  }

  deleteRole(roleID: string){
    const apiURL = this.baseUrl + this.apiAddress.deleteRole+'?RoleID='+ roleID;
    return this._http.post(apiURL, roleID).pipe();
  }
  editRole(roleModel){
    const apiURL = this.baseUrl + this.apiAddress.updateRole;
    return this._http.post(apiURL, roleModel).pipe();
  }
}
